import { Injectable } from '@angular/core';
import { AppService } from './app.service';

@Injectable()
export class BookCategoryService {
  constructor(private app: AppService) {}

  getCategoryLabelSettings(overrideRestriction: boolean = false) {
    let categorySettings = {
      Cat_A: { Disabled: true, Name: 'Category A' },
      Cat_B: { Disabled: true, Name: 'Category B' },
      Cat_C: { Disabled: true, Name: 'Category C' },
      Cat_D: { Disabled: true, Name: 'Category D' },
      Cat_E: { Disabled: true, Name: 'Category E' }
    };
    let category: any = ['Cat_A', 'Cat_B', 'Cat_C', 'Cat_D', 'Cat_E'];
    let letter;
    let string;
    let used;
    let name;
    let restrictBookLocCat;
    let restrictUserCat;

    restrictBookLocCat = this.app.getGlobalOptionValue('Book_Loc_Cat_Letter');
    if (!restrictBookLocCat) {
      restrictBookLocCat = 'N';
    }

    for (var c in category) {
      letter = category[c].substring(4);

      //Get Label
      string = category[c] + '_Name';
      name = this.app.getGlobalOptionValue(string);
      if (name && name != '') {
        categorySettings[category[c]].Name = name;
      }

      if (overrideRestriction) {
        categorySettings[category[c]].Disabled = false;
      } else {
        //Check if Used or Disabled for Role or by Linkage to BookLoc.
        string = 'Use_' + category[c] + '_Ind';
        used = this.app.getGlobalOptionValue(string);
        if (!used || used == '') {
          used = 'N';
        }

        string = 'Book_' + category[c] + '_Restrict_Ind';
        restrictUserCat = this.app.getRoleOptionValue(string);
        if (!restrictUserCat) {
          restrictUserCat = 'N';
        }

        if (used == 'N' || restrictUserCat == 'Y' || restrictBookLocCat == letter) {
          categorySettings[category[c]].Disabled = true;
        } else {
          categorySettings[category[c]].Disabled = false;
        }
      }
    }

    return categorySettings;
  }

  getCategoryForBookLoc(bookLocID: any) {
    let mappedLetter = this.app.getGlobalOptionValue('Book_Loc_Cat_Letter');
    let bookLocLetterValue = '';
    if (mappedLetter && ['A', 'B', 'C', 'D', 'E'].includes(mappedLetter)) {
      bookLocLetterValue = this.app.getLocationOptionValue(bookLocID, 'Book_Loc_Book_Cat');
    }
    if (mappedLetter && bookLocLetterValue) {
      return { Letter: mappedLetter, Value: bookLocLetterValue };
    }
  }
}
